var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");
var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray.js");
var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");
var _toArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toArray.js");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
Object.defineProperty(exports, Symbol.toStringTag, {
  value: 'Module'
});
var breadcrumbs = require('../breadcrumbs.js');
var debugBuild = require('../debug-build.js');
var exports$1 = require('../exports.js');
var integration = require('../integration.js');
var semanticAttributes = require('../semanticAttributes.js');
require('../tracing/errors.js');
var is = require('../utils-hoist/is.js');
var logger = require('../utils-hoist/logger.js');
require('../utils-hoist/time.js');
var spanstatus = require('../tracing/spanstatus.js');
var trace = require('../tracing/trace.js');

// Based on Kamil Ogórek's work on:
// https://github.com/supabase-community/sentry-integration-js

var AUTH_OPERATIONS_TO_INSTRUMENT = ['reauthenticate', 'signInAnonymously', 'signInWithOAuth', 'signInWithIdToken', 'signInWithOtp', 'signInWithPassword', 'signInWithSSO', 'signOut', 'signUp', 'verifyOtp'];
var AUTH_ADMIN_OPERATIONS_TO_INSTRUMENT = ['createUser', 'deleteUser', 'listUsers', 'getUserById', 'updateUserById', 'inviteUserByEmail'];
var FILTER_MAPPINGS = {
  eq: 'eq',
  neq: 'neq',
  gt: 'gt',
  gte: 'gte',
  lt: 'lt',
  lte: 'lte',
  like: 'like',
  'like(all)': 'likeAllOf',
  'like(any)': 'likeAnyOf',
  ilike: 'ilike',
  'ilike(all)': 'ilikeAllOf',
  'ilike(any)': 'ilikeAnyOf',
  is: 'is',
  in: 'in',
  cs: 'contains',
  cd: 'containedBy',
  sr: 'rangeGt',
  nxl: 'rangeGte',
  sl: 'rangeLt',
  nxr: 'rangeLte',
  adj: 'rangeAdjacent',
  ov: 'overlaps',
  fts: '',
  plfts: 'plain',
  phfts: 'phrase',
  wfts: 'websearch',
  not: 'not'
};
var DB_OPERATIONS_TO_INSTRUMENT = ['select', 'insert', 'upsert', 'update', 'delete'];
function markAsInstrumented(fn) {
  try {
    fn.__SENTRY_INSTRUMENTED__ = true;
  } catch (_unused) {
    // ignore errors here
  }
}
function isInstrumented(fn) {
  try {
    return fn.__SENTRY_INSTRUMENTED__;
  } catch (_unused2) {
    return false;
  }
}

/**
 * Extracts the database operation type from the HTTP method and headers
 * @param method - The HTTP method of the request
 * @param headers - The request headers
 * @returns The database operation type ('select', 'insert', 'upsert', 'update', or 'delete')
 */
function extractOperation(method) {
  var headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  switch (method) {
    case 'GET':
      {
        return 'select';
      }
    case 'POST':
      {
        var _headers$Prefer;
        if ((_headers$Prefer = headers['Prefer']) !== null && _headers$Prefer !== void 0 && _headers$Prefer.includes('resolution=')) {
          return 'upsert';
        } else {
          return 'insert';
        }
      }
    case 'PATCH':
      {
        return 'update';
      }
    case 'DELETE':
      {
        return 'delete';
      }
    default:
      {
        return '<unknown-op>';
      }
  }
}

/**
 * Translates Supabase filter parameters into readable method names for tracing
 * @param key - The filter key from the URL search parameters
 * @param query - The filter value from the URL search parameters
 * @returns A string representation of the filter as a method call
 */
function translateFiltersIntoMethods(key, query) {
  if (query === '' || query === '*') {
    return 'select(*)';
  }
  if (key === 'select') {
    return "select(".concat(query, ")");
  }
  if (key === 'or' || key.endsWith('.or')) {
    return "".concat(key).concat(query);
  }
  var _query$split = query.split('.'),
    _query$split2 = _toArray(_query$split),
    filter = _query$split2[0],
    value = _query$split2.slice(1);
  var method;
  // Handle optional `configPart` of the filter
  if (filter !== null && filter !== void 0 && filter.startsWith('fts')) {
    method = 'textSearch';
  } else if (filter !== null && filter !== void 0 && filter.startsWith('plfts')) {
    method = 'textSearch[plain]';
  } else if (filter !== null && filter !== void 0 && filter.startsWith('phfts')) {
    method = 'textSearch[phrase]';
  } else if (filter !== null && filter !== void 0 && filter.startsWith('wfts')) {
    method = 'textSearch[websearch]';
  } else {
    method = filter && FILTER_MAPPINGS[filter] || 'filter';
  }
  return "".concat(method, "(").concat(key, ", ").concat(value.join('.'), ")");
}
function instrumentAuthOperation(operation) {
  var isAdmin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return new Proxy(operation, {
    apply: function apply(target, thisArg, argumentsList) {
      return trace.startSpan({
        name: operation.name,
        attributes: _defineProperty(_defineProperty({}, semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, 'auto.db.supabase'), semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_OP, "db.auth.".concat(isAdmin ? 'admin.' : '').concat(operation.name))
      }, function (span) {
        var _Reflect$apply$then$c;
        return (_Reflect$apply$then$c = Reflect.apply(target, thisArg, argumentsList).then(function (res) {
          if (res && typeof res === 'object' && 'error' in res && res.error) {
            span.setStatus({
              code: spanstatus.SPAN_STATUS_ERROR
            });
            exports$1.captureException(res.error, {
              mechanism: {
                handled: false
              }
            });
          } else {
            span.setStatus({
              code: spanstatus.SPAN_STATUS_OK
            });
          }
          span.end();
          return res;
        }).catch(function (err) {
          span.setStatus({
            code: spanstatus.SPAN_STATUS_ERROR
          });
          span.end();
          exports$1.captureException(err, {
            mechanism: {
              handled: false
            }
          });
          throw err;
        })).then.apply(_Reflect$apply$then$c, _toConsumableArray(argumentsList));
      });
    }
  });
}
function instrumentSupabaseAuthClient(supabaseClientInstance) {
  var auth = supabaseClientInstance.auth;
  if (!auth || isInstrumented(supabaseClientInstance.auth)) {
    return;
  }
  for (var _i = 0, _AUTH_OPERATIONS_TO_I = AUTH_OPERATIONS_TO_INSTRUMENT; _i < _AUTH_OPERATIONS_TO_I.length; _i++) {
    var operation = _AUTH_OPERATIONS_TO_I[_i];
    var authOperation = auth[operation];
    if (!authOperation) {
      continue;
    }
    if (typeof supabaseClientInstance.auth[operation] === 'function') {
      supabaseClientInstance.auth[operation] = instrumentAuthOperation(authOperation);
    }
  }
  for (var _i2 = 0, _AUTH_ADMIN_OPERATION = AUTH_ADMIN_OPERATIONS_TO_INSTRUMENT; _i2 < _AUTH_ADMIN_OPERATION.length; _i2++) {
    var _operation = _AUTH_ADMIN_OPERATION[_i2];
    var _authOperation = auth.admin[_operation];
    if (!_authOperation) {
      continue;
    }
    if (typeof supabaseClientInstance.auth.admin[_operation] === 'function') {
      supabaseClientInstance.auth.admin[_operation] = instrumentAuthOperation(_authOperation, true);
    }
  }
  markAsInstrumented(supabaseClientInstance.auth);
}
function instrumentSupabaseClientConstructor(SupabaseClient) {
  if (isInstrumented(SupabaseClient.prototype.from)) {
    return;
  }
  SupabaseClient.prototype.from = new Proxy(SupabaseClient.prototype.from, {
    apply: function apply(target, thisArg, argumentsList) {
      var rv = Reflect.apply(target, thisArg, argumentsList);
      var PostgRESTQueryBuilder = rv.constructor;
      instrumentPostgRESTQueryBuilder(PostgRESTQueryBuilder);
      return rv;
    }
  });
  markAsInstrumented(SupabaseClient.prototype.from);
}
function instrumentPostgRESTFilterBuilder(PostgRESTFilterBuilder) {
  if (isInstrumented(PostgRESTFilterBuilder.prototype.then)) {
    return;
  }
  PostgRESTFilterBuilder.prototype.then = new Proxy(PostgRESTFilterBuilder.prototype.then, {
    apply: function apply(target, thisArg, argumentsList) {
      var _typedThis$url;
      var operations = DB_OPERATIONS_TO_INSTRUMENT;
      var typedThis = thisArg;
      var operation = extractOperation(typedThis.method, typedThis.headers);
      if (!operations.includes(operation)) {
        return Reflect.apply(target, thisArg, argumentsList);
      }
      if (!(typedThis !== null && typedThis !== void 0 && (_typedThis$url = typedThis.url) !== null && _typedThis$url !== void 0 && _typedThis$url.pathname) || typeof typedThis.url.pathname !== 'string') {
        return Reflect.apply(target, thisArg, argumentsList);
      }
      var pathParts = typedThis.url.pathname.split('/');
      var table = pathParts.length > 0 ? pathParts[pathParts.length - 1] : '';
      var description = "from(".concat(table, ")");
      var queryItems = [];
      var _iterator = _createForOfIteratorHelper(typedThis.url.searchParams.entries()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
            _key = _step$value[0],
            _value = _step$value[1];
          // It's possible to have multiple entries for the same key, eg. `id=eq.7&id=eq.3`,
          // so we need to use array instead of object to collect them.
          queryItems.push(translateFiltersIntoMethods(_key, _value));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var body = Object.create(null);
      if (is.isPlainObject(typedThis.body)) {
        for (var _i3 = 0, _Object$entries = Object.entries(typedThis.body); _i3 < _Object$entries.length; _i3++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i3], 2),
            key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];
          body[key] = value;
        }
      }
      var attributes = _defineProperty(_defineProperty({
        'db.table': table,
        'db.schema': typedThis.schema,
        'db.url': typedThis.url.origin,
        'db.sdk': typedThis.headers['X-Client-Info'],
        'db.system': 'postgresql'
      }, semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, 'auto.db.supabase'), semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_OP, "db.".concat(operation));
      if (queryItems.length) {
        attributes['db.query'] = queryItems;
      }
      if (Object.keys(body).length) {
        attributes['db.body'] = body;
      }
      return trace.startSpan({
        name: description,
        attributes: attributes
      }, function (span) {
        var _Reflect$apply$then;
        return (_Reflect$apply$then = Reflect.apply(target, thisArg, []).then(function (res) {
          if (span) {
            if (res && typeof res === 'object' && 'status' in res) {
              spanstatus.setHttpStatus(span, res.status || 500);
            }
            span.end();
          }
          if (res.error) {
            var err = new Error(res.error.message);
            if (res.error.code) {
              err.code = res.error.code;
            }
            if (res.error.details) {
              err.details = res.error.details;
            }
            var supabaseContext = {};
            if (queryItems.length) {
              supabaseContext.query = queryItems;
            }
            if (Object.keys(body).length) {
              supabaseContext.body = body;
            }
            exports$1.captureException(err, {
              contexts: {
                supabase: supabaseContext
              }
            });
          }
          var breadcrumb = {
            type: 'supabase',
            category: "db.".concat(operation),
            message: description
          };
          var data = {};
          if (queryItems.length) {
            data.query = queryItems;
          }
          if (Object.keys(body).length) {
            data.body = body;
          }
          if (Object.keys(data).length) {
            breadcrumb.data = data;
          }
          breadcrumbs.addBreadcrumb(breadcrumb);
          return res;
        }, function (err) {
          if (span) {
            spanstatus.setHttpStatus(span, 500);
            span.end();
          }
          throw err;
        })).then.apply(_Reflect$apply$then, _toConsumableArray(argumentsList));
      });
    }
  });
  markAsInstrumented(PostgRESTFilterBuilder.prototype.then);
}
function instrumentPostgRESTQueryBuilder(PostgRESTQueryBuilder) {
  var _loop = function _loop() {
    var operation = _DB_OPERATIONS_TO_INS[_i4];
    if (isInstrumented(PostgRESTQueryBuilder.prototype[operation])) {
      return 1; // continue
    }
    PostgRESTQueryBuilder.prototype[operation] = new Proxy(PostgRESTQueryBuilder.prototype[operation], {
      apply: function apply(target, thisArg, argumentsList) {
        var rv = Reflect.apply(target, thisArg, argumentsList);
        var PostgRESTFilterBuilder = rv.constructor;
        debugBuild.DEBUG_BUILD && logger.logger.log("Instrumenting ".concat(operation, " operation's PostgRESTFilterBuilder"));
        instrumentPostgRESTFilterBuilder(PostgRESTFilterBuilder);
        return rv;
      }
    });
    markAsInstrumented(PostgRESTQueryBuilder.prototype[operation]);
  };
  // We need to wrap _all_ operations despite them sharing the same `PostgRESTFilterBuilder`
  // constructor, as we don't know which method will be called first, and we don't want to miss any calls.
  for (var _i4 = 0, _DB_OPERATIONS_TO_INS = DB_OPERATIONS_TO_INSTRUMENT; _i4 < _DB_OPERATIONS_TO_INS.length; _i4++) {
    if (_loop()) continue;
  }
}
var instrumentSupabaseClient = function instrumentSupabaseClient(supabaseClient) {
  if (!supabaseClient) {
    debugBuild.DEBUG_BUILD && logger.logger.warn('Supabase integration was not installed because no Supabase client was provided.');
    return;
  }
  var SupabaseClientConstructor = supabaseClient.constructor === Function ? supabaseClient : supabaseClient.constructor;
  instrumentSupabaseClientConstructor(SupabaseClientConstructor);
  instrumentSupabaseAuthClient(supabaseClient);
};
var INTEGRATION_NAME = 'Supabase';
var _supabaseIntegration = function _supabaseIntegration(supabaseClient) {
  return {
    setupOnce: function setupOnce() {
      instrumentSupabaseClient(supabaseClient);
    },
    name: INTEGRATION_NAME
  };
};
var supabaseIntegration = integration.defineIntegration(function (options) {
  return _supabaseIntegration(options.supabaseClient);
});
exports.DB_OPERATIONS_TO_INSTRUMENT = DB_OPERATIONS_TO_INSTRUMENT;
exports.FILTER_MAPPINGS = FILTER_MAPPINGS;
exports.extractOperation = extractOperation;
exports.instrumentSupabaseClient = instrumentSupabaseClient;
exports.supabaseIntegration = supabaseIntegration;
exports.translateFiltersIntoMethods = translateFiltersIntoMethods;